import React from "react";
import {
  Grid,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

const RenewalsSummaryPaper = ({ classes, paperTitle, currencySymbol }) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Typography variant="h5" className={classes.title}>
            Renewals tracker summary
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>

        <Grid container spacing={3}>
          {/* Monthly Renewals Chart */}
          <Grid item xs={12} md={6}>
            <Card className={classes.chartCard}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Monthly Renewals ({currencySymbol}M)
                </Typography>
                <Box className={classes.chartContainer}>
                  <Skeleton
                    variant="rect"
                    animation="wave"
                    height={250}
                    width="100%"
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Cumulative Renewals Chart */}
          <Grid item xs={12} md={6}>
            <Card className={classes.chartCard}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Cumulative Renewals ({currencySymbol}M)
                </Typography>
                <Box className={classes.chartContainer}>
                  <Skeleton
                    variant="rect"
                    animation="wave"
                    height={250}
                    width="100%"
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default RenewalsSummaryPaper;
